import PresentationBackground from 'modules/onboarding/common/PresentationBackground'
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import PartnerForm from './form/PartnerForm'

export default function RegisterPartner() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const affiliateCode = searchParams.get('ref')?.trim().toUpperCase();

    if (affiliateCode) {
      localStorage.setItem('affiliateCode', affiliateCode);
    }
  }, [searchParams]);

  return (
    <>
      <PresentationBackground
        ComponentToRender={() => <PartnerForm />}
        is='createPartner'
      />
    </>
  )
}
